"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.niceTime = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const consts_1 = require("../consts");
function niceTime(d) {
    const m = (0, moment_timezone_1.default)(d);
    const mins = m.minutes();
    const h = m.format('hh A');
    if (h === '12 AM')
        return mins === 0 ? 'Midnight' : `${m.format('00:mm')}`;
    if (h === '12 PM')
        return mins === 0 ? 'Midday' : `${m.format('12:mm')}`;
    return m.format(consts_1.SimpleTimeFormat);
}
exports.niceTime = niceTime;
